import { GraphQLTypes, InputType, Selector, $ } from '@zeus/index';
import { typedGql } from '@zeus/typedDocumentNode';

const connectionSelector = Selector('Connection')({
  id: true,
  sessionUuid: true,
});

export const GQL_CREATE_CONNECTION = typedGql('mutation')({
  createConnection: [
    {
      createConnectionInput: {
        sessionUuid: $('sessionUuid', 'String!'),
      },
    },
    connectionSelector,
  ],
});

export type StoredConnection = InputType<
  GraphQLTypes['Connection'],
  typeof connectionSelector
>;
